import { gql } from '@apollo/client';

export const GET_PROJECTS = gql`
  query gitProjects($data: GitProjectInput) {
    gitProjects(data: $data) {
      count
      data {
        name
        integrations {
          referenceId
          referenceName
        }
        id
      }
    }
  }
`;

export const GET_TOPICS = gql`
  query ProjectTopics($where: ProjectTopicInput!) {
    projectTopics(where: $where) {
      sourceType
      projectId
      projectTopic {
        id
        topic {
          id
          key
          name
        }
      }
    }
  }
`;

export const GET_ENVIRONMENTS = gql`
  query Environments($where: EnvironmentInput!) {
    environments(where: $where) {
      data {
        name
        isVerified
        id
      }
    }
  }
`;

export const GET_KEY_VALUE_LIST = gql`
  query getKeyValueList($data: GetKeyValueListInput) {
    getKeyValueList(data: $data) {
      projectTopicId
      keys {
        environmentKey
        environmentKeyId
        environmentKeyValues {
          environmentId
          environmentKeyValue
          environmentName
          environmentkeyValueId
          hash
        }
        isPrivate
      }
      environments {
        isVerified
        id
        name
      }
    }
  }
`;

export const GET_PRIVATE_KEY_VALUE = gql`
  query getPrivateKeyValue($data: GetPrivateKeyValueInput) {
    getPrivateKeyValue(data: $data) {
      value
    }
  }
`;

export const GET_HISTORY = gql`
  query viewHistory($data: ViewHistoryInput) {
    viewHistory(data: $data) {
      count
      data {
        id
        log
        firstName
        lastName
        email
        entity
        action
        oldData
        newData
        createdAt
      }
    }
  }
`;
